import axios from "axios";
import { Constants } from "../Constants";

const instance = axios.create({ baseURL: Constants.BASE_URL });

export const fetchAboutUs = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/aboutUs`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const putAboutUs = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.put(`/aboutUs`, data, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const fetchAgent = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/agent`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const putAgent = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.put(`/agent`, data, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const postLogin = async (data: any) => {
  try {
    return await instance.post(`/login`, data);
  } catch (error) {
    throw error;
  }
};

export const postData = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.post(`/datas`, data, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const getData = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/datas`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const deleteData = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.delete(`/datas/${data.id}`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const postTag = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.post(`/tags`, data, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const getTags = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/tags`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const deleteTag = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.delete(`/tags/${data.id}`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const getContacts = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/contact`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const getSubscriptors = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/subs`, httpOptions);
  } catch (error) {
    throw error;
  }
};
